<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-data-table
                :headers="headers"
                :items="variablesClient.variablesClient"
                class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Переменные</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px">

                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ variableClientModel.title }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="variableClientModel.value"
                                                          label="Значение переменной"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="dialog = false">Отмена</v-btn>
                                <v-btn color="blue darken-1" text @click="variablesClientUpdate">Сохранить</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.updated_at="{ item }">
                {{getDate(item.updated_at)}}
            </template>
            <template v-slot:item.value="{ item }">
                {{cutText(item.value)}}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    edit
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'VariablesClient',
    props: ['clientId', 'clientModel', 'selectedMenu'],
    computed: {
        ...mapGetters({
            clients: 'clients/clients'
        })
    },
    data() {
        return {
            dialog: false,
            variablesClient: {
                user_id: null,
                variablesClient: []
            },
            headers: [
                {
                    text: 'Значение',
                    align: 'left',
                    sortable: false,
                    value: 'value'
                },
                { text: 'Обновлен', value: 'updated_at' },
                { text: 'Название', value: 'title' },
                { text: ' ', value: 'action' }
            ],
            variableClientModel: {
                id: null,
                value: null
            }
        }
    },
    methods: {
        saveValue() {
            this.variableClientModel.updated_at = Date.parse(this.theDate) / 1000
            this.$store.dispatch('scenarios/variableClientUpdate', this.clientModel).then(response => {
                if (response.type === 'VariableClientResult') {
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Успешно сохранено!'
                }
                this.snackbar = true
            })
        },
        loadModel() {
            if (this.clientModel.user_id !== null) {
                let variablesClient
                if (this.$store.state.clients.clients.length > 0) {
                    variablesClient = this.$store.state.scenarios.variablesClient.find(client => client.user_id === this.clientModel.user_id)
                }
                if (!variablesClient) {
                    this.$store.dispatch('scenarios/variablesClientAll', { user_id: this.clientModel.user_id }).then(response => {
                        this.variablesClient = response.data
                    })
                } else {
                    this.variablesClient = variablesClient
                }
            }
        },
        editItem(item) {
            this.variableClientModel.id = +item.id
            this.variableClientModel.value = item.value
            this.dialog = true
        },
        variablesClientUpdate() {
            this.$store.dispatch('scenarios/variableClientUpdate', this.variableClientModel).then(() => {
                this.loadModel()
            })
            this.dialog = false
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        getDate(updatedAt) {
            let theDate = new Date(updatedAt * 1000)
            return this.zero(theDate.getHours()) + ':' + this.zero((theDate.getMinutes())) + ' ' + this.zero(theDate.getDate()) + '.' + this.zero((theDate.getMonth() + 1)) + '.' + theDate.getFullYear()
        },
        cutText(text) {
            if (text && text.length > 20) {
                return text.substring(0, 20) + '...'
            } else {
                return text
            }
        }
    },
    watch: {
        selectedMenu(value) {
            if (value === 1) { // если в clientForm выбрали меню с переменными
                this.loadModel()
            }
        }
    }
}
</script>

<style scoped>

</style>
